import { render, staticRenderFns } from "./SubAppList.vue?vue&type=template&id=6320981e&scoped=true"
import script from "./SubAppList.vue?vue&type=script&lang=js"
export * from "./SubAppList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320981e",
  null
  
)

export default component.exports